import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutCarrierObjection } from "./autogen/AutogenLayoutCarrierObjection";

export class CarrierObjection extends AutogenLayoutCarrierObjection {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "objection",
            screenName: "Carrier Objection",
            navigateToUrl: "lme/crm/CarrierObjectionList",
            listLayout: true,
            compositeKeyValues: {
                "type_of": "A"
            }
        });
    }
}
